export default "<mat-spinner class=\"mx-auto my-4\" diameter=\"40\" strokeWidth=\"3\"></mat-spinner>\n";